import React from 'react';

const ContactResume = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.81274 19.875H17.4377" stroke="#5F6177" stroke-width="1.5" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M11.6252 4.37451V15.9995M11.6252 15.9995L15.0159 12.6089M11.6252 15.9995L8.23462 12.6089" stroke="#5F6177" stroke-width="1.5" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default ContactResume;